import { Component} from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-our-team',
  templateUrl: './our-team.component.html',
  styleUrl: './our-team.component.css'
})
export class OurTeamComponent {
  //Team
  teamMembers = [
    {
      img: 'assets/images/team/team-1-sm.jpg',
      alt: 'team-1',
      name: 'Nicholas Hart',
      role: 'Web Developer',
      socials: [
        { icon: 'bi-facebook', link: '#' },
        { icon: 'bi-twitter-x', link: '#' },
        { icon: 'bi-pinterest', link: '#' }
      ]
    },
    {
      img: 'assets/images/team/team-2-sm.jpg',
      alt: 'team-2',
      name: 'Grace Ross',
      role: 'Lead Marketing',
      socials: [
        { icon: 'bi-facebook', link: '#' },
        { icon: 'bi-twitter-x', link: '#' },
        { icon: 'bi-pinterest', link: '#' }
      ]
    },
    {
      img: 'assets/images/team/team-3-sm.jpg',
      alt: 'team-3',
      name: 'Bobby Castro',
      role: 'Project Lead',
      socials: [
        { icon: 'bi-facebook', link: '#' },
        { icon: 'bi-twitter-x', link: '#' },
        { icon: 'bi-pinterest', link: '#' }
      ]
    },
    {
      img: 'assets/images/team/team-4-sm.jpg',
      alt: 'team-4',
      name: 'Luara Prior',
      role: 'Data Scientist',
      socials: [
        { icon: 'bi-facebook', link: '#' },
        { icon: 'bi-twitter-x', link: '#' },
        { icon: 'bi-pinterest', link: '#' }
      ]
    }
  ];

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  //Features
  features = [
    {
      icon: 'bi-palette',
      title: 'Mobile App Design',
      description: 'Not just design - we create emotional, memorable experiences that convert.'
    },
    {
      icon: 'bi-lightbulb',
      title: 'Web Design',
      description: 'Design without purpose is decoration. We blend creativity with business goals.'
    },
    {
      icon: 'bi-magic',
      title: 'UI/UX Design',
      description: 'A creative team obsessed with pushing pixels, solving problems, creating digital.'
    }
  ];

  // OWl Slider
  customOptions: OwlOptions = {
    loop: true,
    dots: true,
    margin:30,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 1,
    navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
  }

  slideStore = [
    {
      title: "Anny Adams",
      subtitle: "CEO/Founder",
      image: "client-1-md.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      title: "Bryan Matt",
      subtitle: "Developer",
      image: "client-2-md.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      title: "David Marks",
      subtitle: "Designer",
      image: "client-3-md.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    }

  ];
}
